import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let blogsSwiperWr = document.querySelectorAll('.blogs-swiper-wr');
blogsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true,
      observeParents: true,
      spaceBetween: 24,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        551: {
          spaceBetween: 16,
          slidesPerView: 1.2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 1.5,
        },
        951: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 38.6,
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      on: {
        init: function () {
          const activeIndex = this.activeIndex;

          [activeIndex + 3, activeIndex + 4].forEach(index => {
            if (this.slides[index]) {
              this.slides[index].classList.add('opacity');
            }
          });
        },

        slideChange: function () {
          this.slides.forEach(slide => slide.classList.remove('opacity'));

          const activeIndex = this.activeIndex;

          [activeIndex + 3, activeIndex + 4].forEach(index => {
            if (this.slides[index]) {
              this.slides[index].classList.add('opacity');
            }
          });
        },
      },
    });

    swiperObserver(swiper);
  }
});
